import React, { useState, useEffect } from "react";
import Footer from "../footer/Footer";
import "./testimonial.css";

import newsscM from "../../Assets/offers/newssc.png";
import newicseM from "../../Assets/offers/newICSE Toppers of 2024.png";
import newcbseM from "../../Assets/offers/newcbse.png";
import newcet from "../../Assets/offers/newmht-cet.png";
import newjee from "../../Assets/offers/JEEAll.jpg";

import { useLocation } from "react-router-dom";
import { Helmet } from "react-helmet";
import Newnavbar from "../newNavbar/Newnavbar";
import LogoContact from "../logoContact/logoContact";
import { FaWhatsapp } from "react-icons/fa";

export default function Testimonial() {
  const location = useLocation();
  const [slide, setSlide] = useState([]);
  useEffect(() => {
    fetchImages();
  }, []);

  async function fetchImages() {
    let data = await fetch(
      "https://nayakstutorials.com/admin/api/success-storys"
    );
    data = await data.json();
    setSlide(data.data);
  }
  return (
    <>
      <Helmet>
        <title>Real Journeys. Real Results. Real Success.</title>
        <meta charSet="utf-8" />
        <meta
          name="title"
          content="Success Stories: Hear From Our Top Achieving Students"
        />
        <meta
          name="description"
          content="Connect with the Nayak's Tutorials Hall of Fame. See how dedication meets expert guidance, and get the confidence you need to become our next success story!"
        />

        <link rel="canonical" href="https://nayakstutorials.com/testimonial/" />
      </Helmet>

      <div className="wpfloat">
        <LogoContact />
        <Newnavbar />
        <div className="FirstheadingDiv">
          <h1>success stories</h1>
        </div>
        <div className="testBtnDiv">
          <a href="#ssc">
            <div
              style={{
                color: location.hash == "#ssc" ? "white" : "#D00000",
                backgroundColor: location.hash == "#ssc" ? "#D00000" : "white",
              }}
              className={`testBtn ${
                location.hash == "" ? "testActive " : "nono"
              }`}
            >
              SSC
            </div>
          </a>
          <a href="#icsc">
            <div
              style={{
                color: location.hash == "#icsc" ? "white" : "#D00000",
                backgroundColor: location.hash == "#icsc" ? "#D00000" : "white",
              }}
              className="testBtn"
            >
              ICSE
            </div>
          </a>
          <a href="#cbsc">
            <div
              style={{
                color: location.hash == "#cbsc" ? "white" : "#D00000",
                backgroundColor: location.hash == "#cbsc" ? "#D00000" : "white",
              }}
              className="testBtn"
            >
              CBSE
            </div>
          </a>
          <a href="#mht-cet">
            <div
              style={{
                color: location.hash == "#mht-cet" ? "white" : "#D00000",
                backgroundColor:
                  location.hash == "#mht-cet" ? "#D00000" : "white",
              }}
              className="testBtn"
            >
              MHT-CET
            </div>
          </a>
          <a href="#jee">
            <div
              style={{
                color: location.hash == "#jee" ? "white" : "#D00000",
                backgroundColor: location.hash == "#jee" ? "#D00000" : "white",
              }}
              className="testBtn"
            >
              JEE
            </div>
          </a>
        </div>
        {location.hash == "#ssc" || location.hash == "" ? (
          <>
            <div className="testtopdiv">
              <img src={newsscM} />
            </div>
          </>
        ) : null}

        {location.hash == "#icsc" ? (
          <>
            <div className="testtopdiv">
              <img src={newicseM} />
            </div>
          </>
        ) : null}

        {location.hash == "#cbsc" ? (
          <>
            <div className="testtopdiv">
              <img src={newcbseM} />
            </div>
          </>
        ) : null}
        {location.hash == "#mht-cet" ? (
          <>
            <div className="testtopdiv">
              <img src={newcet} />
            </div>
          </>
        ) : null}
        {location.hash == "#jee" ? (
          <>
            <div className="testtopdiv">
              <img src={newjee} />
            </div>
          </>
        ) : null}
        <Footer />

        <a href="https://wa.me/+917710010044" target="_blank">
          <div className="wpicon">
            <FaWhatsapp id="faWp" size={50} color="white" />
          </div>
        </a>

        {/* <div className='newenquirediv'><Newenqire /></div> */}
      </div>
    </>
  );
}

// import React, { useState, useEffect } from 'react'
// import Footer from '../footer/Footer'
// import './testimonial.css'

// import { useLocation } from 'react-router-dom'
// import { Helmet } from "react-helmet";
// import Newnavbar from '../newNavbar/Newnavbar'
// import LogoContact from '../logoContact/logoContact'
// import { FaWhatsapp } from "react-icons/fa";

// export default function Testimonial() {
//     const location = useLocation();
//     const [slide, setSlide] = useState([]);

//     const currentTag = location.hash.replace("#", "") || "ssc"; // default SSC

//     useEffect(() => {
//         fetchImages(currentTag);
//     }, [currentTag]);

//     async function fetchImages(tag) {
//         let res = await fetch(`https://nayakstutorials.com/admin/api/success-storys?tag=${tag}`);
//         let data = await res.json();
//         setSlide(data.data || []);
//     }

//     return (
//         <>
//             <Helmet>
//                 <title>Student Testimonials | Nayak's Tutorials</title>
//                 <meta charSet="utf-8" />
//                 <meta name="description" content="Hear from students & parents, who have benefited from our coaching classes. Discover genuine success stories on our dedicated page." />
//                 <link rel="canonical" href="https://nayakstutorials.com/testimonial/" />
//             </Helmet>

//             <div className="wpfloat">
//                 <LogoContact />
//                 <Newnavbar />

//                 <div className='FirstheadingDiv'>
//                     <h1>success stories</h1>
//                 </div>

//                 {/* Buttons */}
//                 <div className='testBtnDiv'>
//                     {["ssc", "icsc", "cbsc", "mht-cet", "jee"].map(tag => (
//                         <a key={tag} href={`#${tag}`}>
//                             <div
//                                 style={{
//                                     color: currentTag === tag ? 'white' : '#D00000',
//                                     backgroundColor: currentTag === tag ? '#D00000' : 'white'
//                                 }}
//                                 className='testBtn'
//                             >
//                                 {tag.toUpperCase()}
//                             </div>
//                         </a>
//                     ))}
//                 </div>

//                 {/* Images */}
//                 <div className='testtopdiv'>
//                     {slide.length > 0 ? (
//                         slide.map((item, i) => (
//                             <img
//                                 key={i}
//                                 src={`https://nayakstutorials.com/uploads/${item.image}`}
//                                 alt={item.title}
//                                 className="testimonial-img"
//                             />
//                         ))
//                     ) : (
//                         <p>No images available for {currentTag.toUpperCase()}</p>
//                     )}
//                 </div>

//                 <Footer />

//                 <a href="https://wa.me/+917710010044" target="_blank" rel="noreferrer">
//                     <div className="wpicon">
//                         <FaWhatsapp id='faWp' size={50} color='white' />
//                     </div>
//                 </a>
//             </div>
//         </>
//     );
// }
